<template>
  <div class="page-body user-profile v-assets-setting">
    <b-row no-gutters>
      <b-col md="12">
        <b-card class="data-card" :show-footer-line="true">
          <b-row>
            <b-col :lg="isSuperAdmin ? '9' : '12'">
              <b-form-input
                v-model="search"
                placeholder="فیلتر رمزارز"
              ></b-form-input>
            </b-col>

            <b-col v-if="isSuperAdmin" lg="3" class="mb-5">
              <b-button @click="syncAssets" variant="primary">
                به روز رسانی رمزارز ها
              </b-button>
            </b-col>
          </b-row>

          <b-row no-gutters>
            <b-col no-gutters lg="12" sm="12" class="right-section">
              <!-- Main table element -->
              <b-overlay
                class="v-asset-profile__overlay"
                :show="loading"
                rounded="sm"
              >
                <b-table
                  :items="filteredAssets"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  stacked="md"
                  empty-text="موردی یافت نشد"
                  show-empty
                >
                  <template #cell(name)="row">
                    <div class="icon-container">
                      <CryptoIcons
                        class="ml-3"
                        :symbol="row.item.symbol"
                        size="30"
                      />
                      {{ row.item.symbol }}
                    </div>
                  </template>
                  <template #cell(available)="row">
                    <b-badge
                      :variant="row.value == true ? 'success' : 'danger'"
                    >
                      {{ row.value == true ? "فعال" : "غیر فعال" }}
                    </b-badge>
                  </template>
                  <template #cell(actions)="row" v-if="isSuperAdmin">
                    <b-button
                      size="sm"
                      @click="setAvailable(row.item.symbol, row.item.available)"
                      :variant="
                        row.item.available == true ? 'danger' : 'success'
                      "
                    >
                      {{ row.item.available == true ? "غیر فعال" : "فعال" }}
                    </b-button>
                    <b-button
                      size="sm"
                      class="mr-3"
                      @click="row.toggleDetails"
                      variant="primary"
                    >
                      تغییر نام
                    </b-button>
                    <b-button
                      :disabled="!row.item.displayName"
                      size="sm"
                      class="mr-3"
                      :to="'/setting/asset/' + row.item.symbol"
                      variant="primary"
                    >
                      تنظیمات شبکه ها
                    </b-button>
                  </template>

                  <template #row-details="row">
                    <b-card>
                      <div>
                        <b-input-group class="asset-name-change mt-3">
                          <b-form-input
                            v-model="row.item.name"
                            placeholder="نام ارز را وارد کنید"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-button
                              @click="
                                renameAsset(row.item.symbol, row.item.name)
                              "
                              variant="primary"
                            >تغییر نام
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </div>
                    </b-card>
                  </template>
                </b-table>
                <div class="paginationNav">
                  <b-row no-gutters>
                    <b-col class="mt-4">
                      <div class="overflow-auto">
                        <b-pagination
                          align="center"
                          v-model="currentPage"
                          :total-rows="totalRows"
                          :per-page="perPage"
                        >
                        </b-pagination>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <template #overlay>
                  <div class="text-center">
                    <b-icon
                      icon="stopwatch"
                      font-scale="3"
                      animation="cylon"
                    ></b-icon>
                    <p id="cancel-label">در حال بارگزاری...</p>
                  </div>
                </template>
              </b-overlay>
            </b-col>
          </b-row>
        </b-card>
        <br/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {ref, computed, onMounted} from "vue";
import {getAssetList, getCoins} from "@/httpservices/Assets";
import {changeAssetStatus} from "@/httpservices/AssetSetting";
import CryptoIcons from "@/components/CryptoIcons";
import store from "@/store"
import {asyncAssets} from "@/httpservices/Assets"

export default {
  name: "assets-setting",

  components: {
    CryptoIcons,
  },

  setup() {
    const loading = ref(true);
    const perPage = ref(15);
    const currentPage = ref(1);
    const totalRows = ref(1);
    const search = ref("");
    const fields = ref([
      {
        key: "name",
        label: "ارز",
        sortDirection: "asc",
        class: "text-right",
      },
      {
        key: "displayName",
        label: "نام",
        sortDirection: "asc",
        class: "text-right",
      },
      {
        key: "symbol",
        label: "نشان",
        sortable: false,
        class: "text-center",
      },
      {
        key: "enabledNetworks",
        label: "شبکه های فعال",
        sortable: false,
        class: "text-center",
      },
      {
        key: "available",
        label: "وضعیت",
        sortable: true,
        sortByFormatted: true,
        filterByFormatted: true,
      },
      {key: "actions", label: "عملیات"},
    ]);

    const assets = ref([]);

    const filteredAssets = computed(() => {
      return assets.value.filter((asset) => {
        const name = asset.name.toLowerCase();
        return name.includes(search.value.toLowerCase());
      });
    });

    onMounted(() => {
      getAssets();
    });

    const getAssets = () => {
      try {
        Promise.all([getAssetList(), getCoins()])
          .then((response) => {
            const publicAssets = Object.values(response[0].data.details);
            const apiAssets = response[1].data;

            publicAssets.sort((a, b) => a.coin.localeCompare(b.coin));
            apiAssets.sort((a, b) => a.symbol.localeCompare(b.symbol));
            assets.value = mergeArray(apiAssets, publicAssets);

            assets.value.sort((a, b) => {
              return a.order - b.order;
            });

            totalRows.value = assets.value.length;
          })
          .catch(() => {
          })
          .finally(() => {
            loading.value = false;
          });
      } catch (error) {
        console.error(error);
      }
    };

    const mergeArray = (arr1 = [], arr2 = []) => {
      let i = -1;
      const copy = arr1.slice();
      copy.forEach((obj) => {
        const helper = [];
        arr2.forEach((obj2) => {
          if (obj.symbol == obj2.coin) {
            i++;
            helper.push(arr2[i]);
          }
        });
        if (helper.length !== 0) {
          obj.displayName = helper[0].name;
          obj.enabled = helper[0].enabled;
          obj.isLegalMoney = helper[0].isLegalMoney;
          obj.networks = helper[0].networks;
          obj.trading = helper[0].trading;
          obj.withdrawAllEnable = helper[0].withdrawAllEnable;
          obj.depositAllEnable = helper[0].depositAllEnable;
          obj.enabledNetworks = helper[0].enabledNetworks;
        }
      });
      return copy;
    };

    const setAvailable = (coin, available) => {
      try {
        loading.value = true;

        let side = " ";

        if (available == true) {
          side = "disable";
        } else {
          side = "enable";
        }

        changeAssetStatus(coin, side)
          .then(() => {
            getAssets();
          })
          .catch((err) => {
            console.error(err);
          });
      } catch (error) {
        console.error(error);
      }
    };

    const isSuperAdmin = computed(() => {
      if (!store.getters['isSuperAdmin']) {
        fields.value.pop();
      }
      return store.getters['isSuperAdmin'];
    })

    const syncAssets = async () => {
      const confirmed = window.confirm('آیا از بروزرسانی مرزارز ها مطمئن هستید؟');
      if (!confirmed) return;
      await asyncAssets();
      this.$swal({
        position: "top-end",
        icon: "success",
        title: "به روزرسانی با موفقیت انجام شد.",
        showConfirmButton: false,
        timer: 3000,
        toast: true,
      });
    }

    return {
      loading,
      search,
      fields,
      filteredAssets,
      assets,
      perPage,
      currentPage,
      totalRows,
      getAssets,
      setAvailable,
      isSuperAdmin,
      syncAssets,
    };
  },
};
</script>

<style lang="scss">
.v-assets-setting {
  .icon-container {
    display: flex;

    .c-checkBox {
      margin-top: -8px;
      border-radius: 8px;
    }
  }
}

.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group
> .input-group-prepend:first-child
> .input-group-text:not(:first-child) {
  border-top-left-radius: 8px !important;
  border-bottom-left-radius: 8px !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.input-group:not(.has-validation) > .form-control:not(:last-child),
.input-group:not(.has-validation) > .custom-select:not(:last-child),
.input-group:not(.has-validation)
> .custom-file:not(:last-child)
.custom-file-label::after {
  border-top-right-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.input-group .form-control:not(:last-child) {
  border-left: 0 !important;
  padding-left: 0 !important;
  border-right: 1px solid rgb(202, 209, 215);
  padding-right: 16px !important;
}
</style>
